import { Properties } from "../../index.browser"
import UAParser from "./UAParser"

export default class DevicePropertyGenerator {
  static generate(global: any): Properties {
    let win
    // Server-Side Ignore
    if (typeof global === "undefined") {
      win = {
        navigator: { userAgent: "", vendor: "", languages: [] },
        screen: {
          width: "",
          height: ""
        }
      }
    } else {
      win = global
    }

    const result = UAParser.parse(win.navigator.userAgent)

    const os = result.os
    const device = result.device
    const screen = win.screen
    const locale = win.navigator.languages?.[0] || ""
    const language = locale.split("-")[0]
    const deviceType = (device.type ?? "pc").replace(/\b(mobile|smarttv)\b/g, (match, p1) => {
      if (p1 === "mobile") return "phone"
      if (p1 === "smarttv") return "tv"
      return match
    })
    let osName = os.name || ""
    let timezone = ""
    try {
      osName = osName.match(/\b(Mac|Windows|Linux|Android|iOS)\b/)?.[0] ?? osName
      orientation = screen.orientation.type.match(/\b(landscape|portrait)\b/)?.[0] ?? ""
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ""
    } catch (e) {}

    return {
      osName: osName,
      osVersion: os.version || "",
      deviceModel: device.model || "",
      deviceType: deviceType,
      deviceVendor: device.vendor || "", // @Deprecated. Use deviceBrand instead
      deviceBrand: device.vendor || "",
      screenWidth: screen.width || "",
      screenHeight: screen.height || "",
      locale: locale,
      language: language,
      timeZone: timezone
    }
  }
}
